<template>
  <div class="solution-page-content">
    <ul class="mb-list">
      <li v-for="(item, idx) in solution"
          :key="idx">
        <div class="img-wraper">
          <img :src="item.cover"
               :alt="item.title" />
        </div>
        <h3 class="title-bg title-black">{{item.title}}</h3>
        <p>
          {{item.abstrct}}
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        solution: [{
          title: '生物识别身份认证',
          subtitle: 'biometric identity authentication.',
          abstrct: '以全渠道多模态生物认证平台为核心，构建身份认证基础能力，建设面向不同业务的认证系统。通过多样化的认证渠道和多种生物识别技术的不同组合，满足业务系统个性化认证需求。平台现已广泛应用于养老、就业、工伤等资格认证和医保控费、教育考试等身份认证领域。',
          cover: require('../../static/images/solution/sol-bio.jpg')
        }, {
          title: '职业培训云平台',
          subtitle: 'PROFESSIONAL EDUCATION CLOUD PLATFORM.',
          abstrct: '运用移动互联网、流媒体、云服务、生物认证等技术，构建集培训、考试、认证、就业资讯等为一体的专业教育平台。同时，有效整合优质培训资源，打造精品课程体系，形成平台运营能力。为学员提供便捷、高效、优质的职业培训通道，实现职业培训与公共服务的新突破。',
          cover: require('../../static/images/solution/sol-training.jpg')
        }, {
          title: '智慧化公共服务平台',
          subtitle: 'intelligent public service platform.',
          abstrct: '敏锐把握从“互联网+”迈入“智能+”时代的用户需求，以自然语言处理、深度学习及知识图谱为核心技术，构建以自然语言为第一交互界面的新型“智能+”公共服务平台，可轻松实现一点接入、自然交互、精准识别、需求感知等智慧化服务，满足用户从信息咨询到业务办理的全方位需求，打造“智能+”时代最前沿、最有效的交互体验。',
          cover: require('../../static/images/solution/sol-service.jpg')
        }, {
          title: '智慧医保',
          subtitle: 'medical insurance.',
          abstrct: '结合医保行业权威专家团队，应用人工智能、区块链、大数据分析等技术，构建新医保数据驱动的行业解决方案。为医疗产业链的各方提供了“三医联动”新局面下的数据服务产品，帮助医保、医院和医药企业制定政策/策略、提升效率。',
          cover: require('../../static/images/solution/sol-host.jpg')
        }]
      }
    },
    methods: {}
  }
</script>

<style lang="scss">
  @import '../assets/style/base.scss';
  @import '../assets/style/public.scss';

  .mobile .solution-page-content {
    .mb-list{
      .title-black{
        &:before{
          display: none;
        }
        &:after{
          content: ' ';
          display: inline-block;
          width: 0;
          height: 0;
          border: .08rem solid transparent;
          border-bottom: .10rem solid #525252;
          position: relative;
          top: -.05rem;
          right: -.10rem;
        }
      }
      .img-wraper{
        border-radius: .04rem;
        overflow: hidden;
        box-shadow: .02rem 0 .09rem rgba(0, 0, 0, .53);
      }
      p{
        padding-left: .02rem;
        padding-right: .02rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/mobile/Solution.vue